


















































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getLotsPrescriber, postLotsArchivePrescriber } from '@/api/api';
import MetaDatatable from '@/models/MetaDatatable';
import Program from '@/models/Program';
import Lot from '@/models/Lot';
import { formatLotType, formatLotStatus } from '@/data/lot';
import { BACKEND_URL } from '@/helpers/constants';
import { buildDocumentUrl } from '@/helpers/document';
import { exposures, types, types2, typesArr, types2Arr } from '@/data/types'; // IMPORT FROM types.ts
import { isBrs } from '@/utils/isBrs';
import getOptionInfos from '@/utils/notifications';
import Lightbox from '@/components/Lightbox.vue';
import sendDocModal from '@/components/prescriber/SendDocModal.vue';
import RentCalculator from '@/components/prescriber/RentCalculator.vue';
import DeptRatioCalculator from '@/components/prescriber/DeptRatioCalculator.vue';
import BRSModal from '@/components/prescriber/BRSModal.vue';
import ProgramReportModal from '@/components/prescriber/ProgramReportModal.vue';
import PdfThumbnail from '@/components/prescriber/PdfThumbnail.vue';


@Component({
    components: {
        Lightbox,
        sendDocModal,
        RentCalculator,
        ProgramReportModal,
        DeptRatioCalculator,
        BRSModal,
        PdfThumbnail,
    },
    filters: {
        formatLotType,
        formatLotStatus,
        euro: function(value: number) {
            return (value != null) ? new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(value) : '';
        },
        formatYMD: (value: string) => {
            let d = new Date(value);
            let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
            let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
            return `(${da}-${mo})`;
        },
        calculGarantRent: function(lot: Lot){
            if(lot.price && lot.profitability){
                return Math.floor(lot.price * (lot.profitability / 100) / 12)+'€/mois';
            }
        },
        calculAmountFurnitureLmnp(lot: Lot){
            if(lot.price && lot.location_amount_property){
                return Math.floor(lot.price - lot.location_amount_property)+' €';
            }
        },
        calculateProfit: function(lot: any){
            if (!isNaN(lot.rent_limit_pinel)){
                let rent = ((lot.rent_limit_pinel * 12) / lot.price) * 100;
                return new Intl.NumberFormat('fr-FR', {
                    maximumFractionDigits: 1,
                }).format(rent) + "%";
            }

            if (isNaN(lot.profitability)) {
                return '';
            }

            return new Intl.NumberFormat('fr-FR', {
                maximumFractionDigits: 1,
            }).format(lot.profitability) + "%";
        },
    },
})


export default class ProgramLotsCard extends Vue {
    BACKEND_URL = BACKEND_URL;
    imageModal: string | null = null;

    planUrl(plan: any) {
        return buildDocumentUrl(this.BACKEND_URL, plan);
    }
    brsOpen: boolean = false;
    
    @Prop() program!: Program;
    
    meta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: 4,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: {
            price: null,
            type: null,
            type2: null,
        },
    };

    lots: Lot[] = [];
    lotStatusColors = {
        acted: '#E26667',
        booked: '#F8B170',
        optionned: '#6CA6D9',
        available: '#66A756',
    };

    loadingContent: boolean = false;
    loadingMore: boolean = false;
    lotsSelected: Lot[] = [];
    
    notAnnual: boolean = false;
    notSubscribed: boolean = false;
    notKochiseActivated: boolean = false;
    openSendDocModal: boolean = false;

    // Filter properties
    budgetMin: number | null = null;
    budgetMax: number | null = null;
    surfaceMin: number | null = null;
    surfaceMax: number | null = null;
    selectedTypes: string[] = [];
    selectedRooms: string[] = [];

    // REPLACE propertyTypes with typesArr from types.ts
    get propertyTypes() {
        const existingTypes = [...new Set(this.lots.map(lot => lot.type))];
        return typesArr.filter(type => existingTypes.includes(type.value));
    }


    // REPLACE roomNumbers with types2Arr from types.ts
        get roomNumbers() {
        const existingRooms = [...new Set(this.lots.map(lot => lot.type2))];
        return types2Arr.filter(room => existingRooms.includes(room.value));
    }

    get exposuresMapping() {
        return exposures;
    }

    get getOptionInfos() {
        return getOptionInfos;
    }

    get availableLotsCount() {
        return this.lots.filter(lot => lot.status === 'available').length;
    }

    get optionnedLotsCount() {
        return this.lots.filter(lot => lot.status === 'optionned').length;
    }

    get bookedLotsCount() {
        return this.lots.filter(lot => lot.status === 'booked').length;
    }


    get filteredLots() {
        let filtered = [...this.lots];

        // Budget filter
        if (this.budgetMin !== null && this.budgetMin !== this.getMinPrice()) {
            filtered = filtered.filter(lot => lot.price >= this.budgetMin!);
        }
        if (this.budgetMax !== null && this.budgetMax !== this.getMaxPrice()) {
            filtered = filtered.filter(lot => lot.price <= this.budgetMax!);
        }

        // Surface filter
        if (this.surfaceMin !== null && this.surfaceMin !== this.getMinSurface()) {
            filtered = filtered.filter(lot => lot.surface_carrez >= this.surfaceMin!);
        }
        if (this.surfaceMax !== null && this.surfaceMax !== this.getMaxSurface()) {
            filtered = filtered.filter(lot => lot.surface_carrez <= this.surfaceMax!);
        }

        // Type filter
        const allExistingTypes = this.getUniqueTypes();
        if (this.selectedTypes.length > 0 && this.selectedTypes.length < allExistingTypes.length) {
            filtered = filtered.filter(lot => this.selectedTypes.includes(lot.type));
        }

        // Rooms filter
        const allExistingRooms = this.getUniqueRooms();
        if (this.selectedRooms.length > 0 && this.selectedRooms.length < allExistingRooms.length) {
            filtered = filtered.filter(lot => this.selectedRooms.includes(lot.type2));
        }

        // Floor filter
        const allExistingFloors = this.getUniqueFloors();
        if (this.selectedFloors.length > 0 && this.selectedFloors.length < allExistingFloors.length) {
            filtered = filtered.filter(lot => this.selectedFloors.includes(lot.floor));
        }

        // Sort
        switch(this.sortBy) {
            case 'price_asc':
                filtered.sort((a, b) => a.price - b.price);
                break;
            case 'price_desc':
                filtered.sort((a, b) => b.price - a.price);
                break;
            case 'surface_asc':
                filtered.sort((a, b) => a.surface_carrez - b.surface_carrez);
                break;
            case 'surface_desc':
                filtered.sort((a, b) => b.surface_carrez - a.surface_carrez);
                break;
        }

        return filtered;
    }



    getMinPrice() {
        const prices = this.lots.map(lot => lot.price).filter(p => p > 0);
        return prices.length > 0 ? Math.min(...prices) : 0;
    }

    getMaxPrice() {
        const prices = this.lots.map(lot => lot.price).filter(p => p > 0);
        return prices.length > 0 ? Math.max(...prices) : 0;
    }

    getMinSurface() {
        const surfaces = this.lots.map(lot => lot.surface_carrez).filter(s => s > 0);
        return surfaces.length > 0 ? Math.min(...surfaces) : 0;
    }

    getMaxSurface() {
        const surfaces = this.lots.map(lot => lot.surface_carrez).filter(s => s > 0);
        return surfaces.length > 0 ? Math.max(...surfaces) : 0;
    }

    // FIX: Use Object.keys() to get all unique types from the types object
    getUniqueTypes() {
        return Object.keys(types);
    }

    // FIX: Use Object.keys() to get all unique rooms from the types2 object
    getUniqueRooms() {
        return Object.keys(types2);
    }

    getUniqueFloors() {
    return [...new Set(this.lots.map(lot => lot.floor).filter(f => f))];
    }

    toggleFloor(floor: string) {
        const index = this.selectedFloors.indexOf(floor);
        if (index > -1) {
            this.selectedFloors.splice(index, 1);
        } else {
            this.selectedFloors.push(floor);
        }
    }


    brs(lot: Lot) {
        return isBrs(lot, this.program);
    }

    async created() {
        await this.loadAllLots();
    }


        initializeFilters() {
            if (this.lots.length > 0) {
                // Initialize budget with min and max prices
                const prices = this.lots.map(lot => lot.price).filter(p => p > 0);
                if (prices.length > 0) {
                    this.budgetMin = Math.min(...prices);
                    this.budgetMax = Math.max(...prices);
                }

                // Initialize surface with min and max surface_carrez
                const surfaces = this.lots.map(lot => lot.surface_carrez).filter(s => s > 0);
                if (surfaces.length > 0) {
                    this.surfaceMin = Math.min(...surfaces);
                    this.surfaceMax = Math.max(...surfaces);
                }

                // Initialize with only types/rooms/floors that exist in lots
                this.selectedTypes = this.getUniqueTypes();
                this.selectedRooms = this.getUniqueRooms();
                this.selectedFloors = this.getUniqueFloors(); // NEW
            }
        }

    async fetch() {
        if (!this.program || !this.program.id) {
            return;
        }

        this.loadingContent = true;
        try {
            const { data } = await getLotsPrescriber(this.program.id, this.meta);
            this.lots = data.data;
            this.meta.total = data.meta.total;
            this.meta.pages = data.meta.pages;
            this.meta.page = data.meta.page;
        } catch (e) {
            (this as any).$vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Impossible de charger les lots.',
            });
        } finally {
            this.loadingContent = false;
        }
    }

    get hasMoreLots() {
        return this.meta.pages > 0 && this.meta.page < this.meta.pages - 1;
    }

    async loadMore() {
        if (!this.hasMoreLots || this.loadingMore || !this.program.id) return;
        this.loadingMore = true;
        try {
            const nextMeta = { ...this.meta, page: this.meta.page + 1 };
            const { data } = await getLotsPrescriber(this.program.id, nextMeta);
            this.lots = [...this.lots, ...data.data];
            this.meta.total = data.meta.total;
            this.meta.pages = data.meta.pages;
            this.meta.page = data.meta.page;
        } catch (e) {
            (this as any).$vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Impossible de charger les lots suivants.',
            });
            return;
        } finally {
            this.loadingMore = false;
        }
    }

    async loadAllLots() {
        await this.fetch();
        while (this.hasMoreLots) {
            await this.loadMore();
        }
        this.initializeFilters();
    }

    // Lot plans live on a cross-origin host without CORS headers, so a HEAD
    // fetch() here always throws instead of resolving — it's not a usable
    // existence check and only floods the console with blocked-CORS errors.
    // Broken plans are instead caught by PdfThumbnail's own <img> @error event.

    get loadingProgress() {
        if (this.meta.total === 0) return 0;
        return Math.round((this.lots.length / this.meta.total) * 100);
    }

    get isLoadingLots() {
        return this.loadingContent || this.loadingMore;
    }

    async downloadDocs() {
        if(this.lotsSelected.length > 5) {
            const $vs = (this as any).$vs;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: "Vous ne pouvez pas sélectionner plus de 5 lots",
            });
            return false;
        }
        
        let programName = this.program.name;
        let companyName = this.program.promoter.name;
        let filename = `${companyName}_${programName}.zip`;
        
        postLotsArchivePrescriber({
            lots: this.lotsSelected.map(lot => lot.id || -1),
        })
            .then(({ data }) => {
                saveAs(data, filename);
            })
            .catch(async error => {
                const $vs = (this as any).$vs;
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: JSON.parse(await error.response.data.text()).message,
                });

                if (error.response.status === 403) {
                    location.reload();
                }
            });
    }

    async lotSelect(lot: Lot) {
        if(lot && this.lotsSelected.find(x => x.id === lot.id)) {
            const index = this.lotsSelected.indexOf(lot);
            if (index > -1) {
                this.lotsSelected.splice(index, 1);
            }
        } else {
            this.lotsSelected.push(lot);
        }
    }

    isLotSelected(lot: Lot) {
        const el = this.lotsSelected.find(x => x.id === lot.id);
        return el !== undefined;
    }

    async OpenSendDocModal() {
        this.openSendDocModal = true;
    }

    toggleType(type: string) {
        const index = this.selectedTypes.indexOf(type);
        if (index > -1) {
            this.selectedTypes.splice(index, 1);
        } else {
            this.selectedTypes.push(type);
        }
    }

    toggleRoom(room: string) {
        const index = this.selectedRooms.indexOf(room);
        if (index > -1) {
            this.selectedRooms.splice(index, 1);
        } else {
            this.selectedRooms.push(room);
        }
    }

    applyFilters() {
        // Filters are applied via computed property filteredLots
    }

    resetFilters() {
        this.budgetMin = this.getMinPrice();
        this.budgetMax = this.getMaxPrice();
        this.surfaceMin = this.getMinSurface();
        this.surfaceMax = this.getMaxSurface();
        this.selectedTypes = this.getUniqueTypes();
        this.selectedRooms = this.getUniqueRooms();
        this.selectedFloors = this.getUniqueFloors();
        this.sortBy = 'price_asc';
    }

    includesTaxes(values: number[]) {
        if (this.tax_system_category) {
            for (let index in values) {
                if (this.tax_system_category.includes(values[index])) {
                    return true;
                }
            }
        }
        return false;
    }

    get tax_system_category() {
        if (!this.program || !this.program.tax_system || this.program.tax_system.length < 1) {
            return;
        }
        
        let arrayReturn = [];
        let arraytaxSystem = this.program.tax_system;
        
        for (let i = 0; i < arraytaxSystem.length; i++) {
            if (['Pinel / Rés. principale', 'PLS', 'PINEL Sénior', 'PINEL Outre Mer'].includes(arraytaxSystem[i])) {
                arrayReturn.push(1);
            } else if (['Denormandie', 'Malraux', 'PINEL Ancien', 'Monuments historiques', 'Déficits fonciers', 'Loi COSSE Ancien-Louer Abordable'].includes(arraytaxSystem[i])) {
                arrayReturn.push(2);
            } else if (['LMNP VEFA Divers', 'LMNP Étudiant', 'LMNP Senior', 'LMNP Tourisme', 'LMNP EHPAD', 'LMNP Coliving', 'LMNP Colocation', 'LMNP CRT', 'CIIC Corse', 'Revente LMNP', 'Revente LMNP Tourisme', 'Revente LMNP Étudiant', 'Revente LMNP Sénior', 'Revente LMNP Rés', 'Revente LMNP EHPAD'].includes(arraytaxSystem[i])) {
                arrayReturn.push(3);
            } else if (arraytaxSystem[i] === 'Démembrement de propriété') {
                arrayReturn.push(4);
            } else if (arraytaxSystem[i] === 'Projet construction') {
                arrayReturn.push(5);
            } else if (arraytaxSystem[i] === 'Revente fin défiscalisation') {
                arrayReturn.push(6);
            } else if (arraytaxSystem[i] === 'RP Tva Réduite/Prix Maitrisé') {
                arrayReturn.push(7);
            } else if (arraytaxSystem[i] === 'BRS') {
                arrayReturn.push(9);
            } else if (arraytaxSystem[i] === 'LLI') {
                arrayReturn.push(10);
            }
        }
        return arrayReturn;
    }

    get hasBrsPrice() {
        if (this.lots) {
            for (let i = 0; i < this.lots.length; i++) {
                if (this.lots[i].price_reduced_brs > 0){
                    return true;
                }
            }
        }
        return false;
    }

    get hasReducedPrice() {
        return this.includesTaxes([7]);
    }

    get hasLliPrice() {
        return this.includesTaxes([10]);
    }

    get hasReventeTaxSystem() {
        if (!this.program || !this.program.tax_system || this.program.tax_system.length < 1) {
            return false;
        }
        
        const reventeTaxSystems = [
            'Revente LMNP',
            'Revente LMNP Tourisme',
            'Revente LMNP Étudiant',
            'Revente LMNP Sénior',
            'Revente LMNP Rés',
            'Revente LMNP EHPAD'
        ];
        
        return this.program.tax_system.some(taxSystem => 
            reventeTaxSystems.includes(taxSystem)
        );
    }

    get shouldShowLmnpTvaRecup() {
        return this.includesTaxes([3]) && !this.hasReventeTaxSystem;
    }

    hasAdditionalPrices(lot: Lot) {
        return (this.includesTaxes([9]) && lot.price_reduced_brs) ||
               (this.includesTaxes([7]) && lot.price_vat_reduce_or_controlled) ||
               (this.includesTaxes([10]) && lot.price_reduced_lli) ||
               (this.includesTaxes([4]) && lot.prix_nue_propriete);
    }

    hasLmnpInfo(lot: Lot) {
        return lot.location_amount_property || lot.location_amount_furniture || this.shouldShowLmnpTvaRecup;
    }

    hasFoncierTravauxInfo(lot: Lot) {
        return lot.amount_property || lot.amount_work || lot.amount_work_no_defisc;
    }

    hasGarantRent(lot: any) {
        return this.includesTaxes([3]) && !!(lot.price && lot.profitability);
    }

    hasProfitability(lot: any) {
        if (lot.rent_limit_pinel !== null && lot.rent_limit_pinel !== undefined && !isNaN(lot.rent_limit_pinel)) {
            return true;
        }
        return lot.profitability !== null && lot.profitability !== undefined && !isNaN(lot.profitability);
    }

    hasParkingInfo(lot: Lot) {
        return lot.name_parking1 || lot.name_parking2 || lot.name_parking3;
    }

    hasDetails(lot: Lot) {
        return (!this.includesTaxes([5]) && lot.floor) || 
               (!this.includesTaxes([5]) && lot.exposure && lot.exposure.trim());
    }

    hasFinancialInfo(lot: Lot) {
        return (!this.includesTaxes([2,3,4,6]) && lot.program && lot.program.address && lot.program.address.zone) || true;
    }



    selectedFloors: string[] = [];
    sortBy: string = 'price_asc';
    lotPlanBroken: number[] = [];

    markPlanBroken(lotId: number) {
        if (!this.lotPlanBroken.includes(lotId)) {
            this.lotPlanBroken.push(lotId);
        }
    }

    openLotPlan(lot: Lot) {
        if (!lot.plan || !lot.id) return;
        const url = this.planUrl(lot.plan);
        // No HEAD pre-check here either — same cross-origin/no-CORS host as
        // above, so it would always throw and just delay the window.open.
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    // ========================================
    // PART 2: ADD COMPUTED PROPERTIES
    // ========================================
    // Add these after roomNumbers computed property

    // Floor options - only show floors that exist in lots
    get floorOptions() {
        const existingFloors = [...new Set(this.lots.map(lot => lot.floor).filter(f => f))];
        // Sort floors: RDC/RDJ first, then numbers, then others
        return existingFloors.sort((a, b) => {
            if (a === 'RDC' || a === 'RDJ') return -1;
            if (b === 'RDC' || b === 'RDJ') return 1;
            const aNum = parseInt(a);
            const bNum = parseInt(b);
            if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;
            if (!isNaN(aNum)) return -1;
            if (!isNaN(bNum)) return 1;
            return a.localeCompare(b);
        }).map(floor => ({ text: floor, value: floor }));
    }

    // Sort options
    get sortOptions() {
        return [
            { text: 'Prix Croissant', value: 'price_asc' },
            { text: 'Prix Décroissant', value: 'price_desc' },
            { text: 'Surface Habitable Croissante', value: 'surface_asc' },
            { text: 'Surface Habitable Décroissante', value: 'surface_desc' }
        ];
    }



                    // New Function For the Report GEneration ****************
                
                reportModalActive: boolean = false;

                openReportModal() {
                    this.reportModalActive = true;
                }

                handleReportGeneration(reportConfig: any) {
                    console.log('Generating PDF with config:', reportConfig);
                    
                    // @ts-ignore
                    this.$vs.notify({
                        color: 'success',
                        title: 'Génération en cours',
                        text: 'Le rapport PDF est en cours de génération...'
                    });
                    
                    this.reportModalActive = false;
                }








}

